{
  "services-mobile-top-ups": {
    "meta": {
      "title": "Mobile Top-ups - MAJORITY",
      "description": "Save on sending mobile top-ups around the world! Send instant top-ups with no hidden fees."
    },
    "hero": {
      "title": "International mobile top-ups",
      "body": "Send top-ups to 35+ destinations instantly.",
      "cta": "I send top-ups to",
      "features": "Unlimited, no-fee top-ups\nInstant, secure delivery"
    },
    "unlimited_content_box": {
      "tagline": "Mobile top-ups",
      "title": "Send unlimited, no-fee mobile top-ups home",
      "body": "Top up loved ones back home without spending extra on fees. Send phone credits to 35+ countries including Cuba, Mexico, Nigeria, Colombia, and more. Family and friends can use your top-ups to call, send messages, and surf the internet."
    },
    "instant_content_box": {
      "tagline": "Mobile top-ups",
      "title": "Instant, secure delivery",
      "body": "MAJORITY’s mobile top-ups are instant and always sent securely. That way your family isn’t waiting around for their credits to get in touch with you."
    },
    "faq": {
      "title": "FAQ",
      "faqs": [
        {
          "question": "Can I use MAJORITY if I’m not a migrant?",
          "answer": "Yes! Everyone is welcome. If any of the features in our app interest you, sign up and give it a try."
        },
        {
          "question": "Is MAJORITY a bank?",
          "answer": "We are a financial membership app providing banking services through our partner, Axiom Bank, N.A., Member FDIC. The signature MAJORITY Visa® debit card is also issued by Axiom Bank pursuant to a license from Visa U.S.A. Inc. The card can be used anywhere Visa is accepted!"
        },
        {
          "question": "What is MAJORITY?",
          "answer": "MAJORITY is the first-ever financial membership built by migrants, for migrants. After signing up, you get an FDIC-insured account with no overdraft fees, a Visa® Debit Card, fee-free money transfers, free and low-cost international calls, and more!"
        },
        {
          "question": "Where is MAJORITY?",
          "answer": "We have offices in Houston, Miami, and Stockholm, Sweden. Visit us at MAJORITY Meetup Houston, located in 9801 V Bissonnet Street, Houston, Texas 77036, United States."
        },
        {
          "question": "Will my money be safe with MAJORITY?",
          "answer": "Absolutely. Your MAJORITY account is FDIC-insured, so whether you are in the US or abroad, the money in your account is protected up to $250,000 by the FDIC. Plus, you’ll be able to access your app anywhere, so there’s nothing to worry about."
        }
      ]
    }
  }
  
}